import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HouseFilled2: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 21, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 20) / 21}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6475 8.83739L17.4649 5.65458V1.97791C17.4649 1.31311 16.9262 0.774352 16.2604 0.774352C15.5962 0.774352 15.0575 1.31311 15.0575 1.97791V3.24717L12.6878 0.877238C11.5162 -0.293804 9.4791 -0.291726 8.31015 0.879358L0.352326 8.83739C-0.117442 9.30811 -0.117442 10.0698 0.352326 10.5398C0.822306 11.0104 1.58541 11.0104 2.05522 10.5398L10.0123 2.58153C10.2715 2.32366 10.7284 2.32366 10.9862 2.58077L18.9447 10.5398C19.1806 10.7751 19.4883 10.8921 19.7959 10.8921C20.1041 10.8921 20.4123 10.775 20.6476 10.5398C21.1175 10.0698 21.1175 9.30816 20.6475 8.83739Z"
        fill="currentColor"
      />
      <path
        d="M10.923 4.86667C10.6918 4.63559 10.3175 4.63559 10.0869 4.86667L3.08723 11.8646C2.97672 11.9751 2.91406 12.126 2.91406 12.2834V17.3874C2.91406 18.5851 3.88514 19.5562 5.08274 19.5562H8.54831V14.1889H12.4609V19.5562H15.9265C17.1241 19.5562 18.0951 18.5851 18.0951 17.3875V12.2834C18.0951 12.126 18.033 11.9751 17.922 11.8646L10.923 4.86667Z"
        fill="currentColor"
      />
    </svg>
  )
})

HouseFilled2.displayName = 'HouseFilled2'
